/**
 * @generated SignedSource<<53228cb5bc72190d227e5b26821b93c9>>
 * @relayHash 3aab4768aa02f28d4c48f66fd7385a22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ebaa7cef36f7990b4eddb16b57e79502554019e9f5f898931b915f55e976b066

import type { ConcreteRequest, Query } from 'relay-runtime';
export type OnboardingWizardInnerPermissionsQuery$variables = {
  cloudId: string;
  skipDelegatedAdminCheck: boolean;
};
export type OnboardingWizardInnerPermissionsQuery$data = {
  readonly jira?: {
    readonly canManageCustomOnboarding: boolean | null | undefined;
  } | null | undefined;
};
export type OnboardingWizardInnerPermissionsQuery = {
  response: OnboardingWizardInnerPermissionsQuery$data;
  variables: OnboardingWizardInnerPermissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipDelegatedAdminCheck"
  }
],
v1 = [
  {
    "condition": "skipDelegatedAdminCheck",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "canManageCustomOnboarding",
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Literal",
                "name": "key",
                "value": "ADMINISTER"
              }
            ],
            "kind": "ScalarField",
            "name": "hasGlobalPermission"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "OnboardingWizardInnerPermissionsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OnboardingWizardInnerPermissionsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ebaa7cef36f7990b4eddb16b57e79502554019e9f5f898931b915f55e976b066",
    "metadata": {},
    "name": "OnboardingWizardInnerPermissionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8e95b9b19c9d24df2fac346e3dbdf015";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
